export default __webpack_public_path__ + "static/media/kusama-inner.15f2f0ec.svg";